export const kebabCase = (str: string): string => (str.match(/[a-zA-Z0-9]+/g) || []).join('-').toLowerCase() || 'na';

export const stripHtml = (str: string): string => str.replace(/\<.*?\>/g, '').trim();